import * as React from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import Svg from '@splunk/react-icons/SVGEnterprise';

const Timeline = (props: React.ComponentProps<typeof Svg>): React.ReactElement<SVGElement> => (
    <Svg screenReaderText={_('Timeline')} fill="currentColor" viewBox="0 0 150 100" {...props}>
        <g opacity=".15">
            <path d="m47.4445 24h-46.4445v6.2316h46.4445z" />
            <path d="m103.432 33.3474h-102.432v6.2315h102.432z" />
            <path d="m47.4445 42.6947h55.9875v6.2316h-55.9875z" />
            <path d="m149 52.0421h-148v6.2316h148z" />
            <path d="m61 61.3895h68.395v6.2315h-68.395z" />
            <path d="m149 70.7368h-42.5v6.2316h42.5z" />
        </g>
    </Svg>
);

export default Timeline;
